import Vue from 'vue'
import Router from 'vue-router'
import general from './general'

const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)
// 路由集合
let routers = [...general]
//
/**
 * general 公共部分
 */
export default new Router({
  mode: 'history',
  base: '/workOrder/',
  routes: routers
})



// WEBPACK FOOTER //
// ./src/router/index.js